
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FF8C00","d":"M0 0h48v48H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M4 4h18v5H4zm0 9h18v5H4zm0 9h18v5H4zM26 4h18v5H26zm0 9h18v5H26zm0 9h18v5H26zm0 9h18v5H26z"}}),_c('circle',{attrs:{"cx":"13","cy":"38","r":"8","fill":"#fff"}})])
          )
        }
      }
    